import { render } from "./PreviewSendResp.vue?vue&type=template&id=59e52b8e"
import script from "./PreviewSendResp.vue?vue&type=script&lang=js"
export * from "./PreviewSendResp.vue?vue&type=script&lang=js"

import "./PreviewSendResp.vue?vue&type=style&index=0&id=59e52b8e&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__